import React from 'react'
import { XCircle } from 'react-bootstrap-icons'
import ReactSelect from '../../../FormComponents/ReactSelect'
import DatePicker from '../../../FormComponents/DatePicker'
import Input from '../../../FormComponents/Input'
import InfoTooltip from '../../../FormComponents/InfoTooltip'
import Button from '../../../Shared/Button'
import { ITEM_TYPE_OPTIONS, EVENT_OPTIONS } from '../auditLogConstants'

export default function AuditLogFilters({ filters, onChange, onReset, projectManagerOptions, campaignOptions }) {
  const set = (key) => (value) => onChange({ ...filters, [key]: value })
  const hasActiveFilters = Object.values(filters).some(value => value !== null)

  return (
    <div className="rounded-lg border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter p-6">
      <div className="flex items-center justify-between mb-5">
        <p className="text-sm font-semibold text-rb-black dark:text-white">Filters</p>
        <Button variant="subtle" size="sm" onClick={onReset} disabled={!hasActiveFilters}>
          <span className="flex items-center gap-1">
            <XCircle />
            Reset
          </span>
        </Button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-6 gap-x-4 gap-y-5">
        <div>
          <div className="flex items-center gap-1 mb-1">
            <label className="block text-sm font-medium text-rb-black dark:text-rb-dark-mode-text-grey">Campaign</label>
            <InfoTooltip text="Only matches records that still exist. A deleted action or status's history won't show up here, even though it's still visible via the other filters." />
          </div>
          <ReactSelect
            noLabelPadding
            placeholder="All campaigns"
            isClearable
            options={campaignOptions}
            value={filters.campaignId}
            onChange={option => set('campaignId')(option?.value ?? null)}
          />
        </div>
        <div>
          <ReactSelect
            label="Model"
            noLabelPadding
            placeholder="All models"
            isClearable
            options={ITEM_TYPE_OPTIONS}
            value={filters.itemType}
            onChange={option => set('itemType')(option?.value ?? null)}
          />
        </div>
        <div>
          <ReactSelect
            label="Event"
            noLabelPadding
            placeholder="All events"
            isClearable
            options={EVENT_OPTIONS}
            value={filters.event}
            onChange={option => set('event')(option?.value ?? null)}
          />
        </div>
        <div>
          <ReactSelect
            label="Changed by"
            noLabelPadding
            placeholder="Anyone"
            isClearable
            options={projectManagerOptions}
            value={filters.whodunnitId}
            onChange={option => set('whodunnitId')(option?.value ?? null)}
          />
        </div>
        {/* Record ID/From/To are lighter-weight fields (a number, two dates) than the
            dropdowns above, so they share one grid cell instead of each claiming a
            full column - From/To end up at half the width Record ID gets. */}
        <div className="sm:col-span-2 lg:col-span-2 grid grid-cols-[2fr_1fr_1fr] gap-3">
          <Input
            label="Record ID"
            noLabelPadding
            topMargin=""
            type="number"
            placeholder="e.g. 1234"
            value={filters.itemId ?? ''}
            onChange={e => set('itemId')(e.target.value || null)}
          />
          <DatePicker
            label="From"
            noLabelPadding
            topMargin=""
            selected={filters.dateFrom}
            onChange={set('dateFrom')}
          />
          <DatePicker
            label="To"
            noLabelPadding
            topMargin=""
            selected={filters.dateTo}
            onChange={set('dateTo')}
          />
        </div>
      </div>
    </div>
  )
}
